import fordStyles from "./Loading.module.scss";
import lincolnStyles from "./Loading-Lincoln.module.scss";
import React, { useState, useEffect } from "react";
import { ofType } from "../../common/PubSub";
import { IS_FORD_BRAND } from "../../utils/EmpUtil";

const Loading = (props) => {
  const [styles, setStyles] = useState(
    props.brand && !IS_FORD_BRAND(props.brand) ? lincolnStyles : fordStyles
  );

  useEffect(() => {
    const subscription = ofType("brandChanged").subscribe((response) => {
      setStyles(IS_FORD_BRAND(response.data) ? fordStyles : lincolnStyles);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <div
      className={styles.homeLoaderWrapper}
      id="loading"
      style={{ display: "none" }}
    >
      <span>
        <div className={styles.loaderImageHomeLoaderRegular} />
      </span>
    </div>
  );
};

export default Loading;
